import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'ossImport',
    position: [ButtonPosition.tableToolArea],
    action: () => { },
};
